const messages = {
    en: {
        role: {
            permissions: {
                CALENDAR_SHOW: "View Calendar",
                CALENDAR_UPDATE: "Modify Calendar",
                CALENDAR_CREATE: "Create Calendar",
                CALENDAR_DELETE: "Delete Calendar"
            }
        }
    },
    es: {
        role: {
            permissions: {
                CALENDAR_SHOW: "Ver Calendario",
                CALENDAR_UPDATE: "Modificar Calendario",
                CALENDAR_CREATE: "Crear Calendario",
                CALENDAR_DELETE: "Eliminar Calendario"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                CALENDAR_SHOW: "Ver Calendário",
                CALENDAR_UPDATE: "Modificar Calendário",
                CALENDAR_CREATE: "Criar Calendário",
                CALENDAR_DELETE: "Eliminar Calendário"
            }
        }
    }
}

export default messages
